
/**
 * 인증 제공자
 */
export type UserPageResponseContentItemProvider = typeof UserPageResponseContentItemProvider[keyof typeof UserPageResponseContentItemProvider];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UserPageResponseContentItemProvider = {
  LOCAL: 'LOCAL',
  GOOGLE: 'GOOGLE',
  GITHUB: 'GITHUB',
  FACEBOOK: 'FACEBOOK',
} as const;
